export const TiaTameraEvents = {};

TiaTameraEvents.hasActiveEvent = () => {
  TiaTameraEvents.visitingPrison();
}

TiaTameraEvents.displayHint = () => {
  
}

TiaTameraEvents.visitingPrison = () => {
  // czy odbyło się pierwsze przejście przez portal do piekła
  if(!EventStateService.elianaFirstTimeThroughPortal) {
    return false;
  }

  return !EventStateService.tiaTameraVisitingPrison;
}
